import $ from 'jquery';
import JQueryView from '@/common/views/jqueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('#form_view');

    // @ts-expect-error 型 'JQuery<HTMLElement>' に存在しない jpostal を参照するため
    $('#company_zip_code').jpostal({
      postcode: ['#company_zip_code'],
      address: {
        '#company_prefecture_id': '%3',
        '#company_city': '%4',
      },
    });
  }
}
